import { SUBSCRIPTION_PRICE_FULL } from './constants';

export const getFreeTrialVisitedStorageKey = (tenantId: number) =>
  `free_trial_visited_${tenantId}`;

export enum SubscriptionPrice {
  full = SUBSCRIPTION_PRICE_FULL,
}

export enum SubscriptionPlans {
  _365 = '1year',
}

export enum PaymentRedirectUrl {
  newSubscription = '/annual-subscription/new',
  renewSubscription = '/annual-subscription/renew',
  freeTrial = '/free-trial',
}

export enum TrackingEvents {
  pageView = 'page_view',
  generateLead = 'generate_lead',
  signUp = 'sign_up',
  emailVerified = 'email_verified',
  creationEntreprise = 'creation_entreprise',
  skipKyc = 'skip_kyc',
  submitKyc = 'submit_kyc',
  leadQualified = 'lead_qualified',
  beginCheckout = 'begin_checkout',
  contractSignatureInitiated = 'contract_signature_initiated',
  purchase = 'purchase',
  purchaseInApp = 'purchase_in_app',
  firstLogin = 'first_login',
  tutorialInitiated = 'tutorial_initiated',
  tutorialCompleted = 'tutorial_completed',
  importInvoices = 'import_invoices',
  login = 'login',
  selectItem = 'select_item',
  inAppPurchase = 'in-app-purchase',
  contractSigned = 'contract_signed',
}
